import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Contact } from "./components/contact";
import { Map } from "./components/map";
import { API } from "./components/api";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import MangagePage from "./components/Mangagepage";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const HomePage = ({ data }) => (
  <>
    <Navigation data={data.GeoLogo} />
    <Header data={data.Header} />
    <About data={data.About} />
    <API data={data.Gallery} />
    <Map data={data.Map} />
    <Contact data={data.Contact}/>
  </>
);

const CustomPage = ({ data }) => (
  <>
    <MangagePage />
  </>
);

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage data={landingPageData} />} />
        <Route path="/asks" element={<CustomPage data={landingPageData} />} />
      </Routes>
    </Router>
  );
};

export default App;
